import type {
  SourceSyncOperationMetadataBrowserbase,
  SourceSyncOperationMetadataFileUpload,
  SourceSyncOperationMetadataWebhook,
  SourceSyncOperationMetadataWikipedia,
} from "@gx/ts-contracts/services/source/resources/source_sync_operation_metadata/source_sync_operation_metadata_pb";
import type { SourceSyncOperationResource } from "@gx/ts-contracts/services/source/resources/source_sync_operation_pb";

export function isSourceSyncOperationWikipedia(
  op: SourceSyncOperationResource,
): op is SourceSyncOperationResource & {
  metadata: {
    metadata: { case: "metadataWikipedia"; value: SourceSyncOperationMetadataWikipedia };
  };
} {
  return op.metadata?.metadata?.case === "metadataWikipedia";
}

export function isSourceSyncOperationBrowserbase(
  op: SourceSyncOperationResource,
): op is SourceSyncOperationResource & {
  metadata: {
    metadata: { case: "metadataBrowserbase"; value: SourceSyncOperationMetadataBrowserbase };
  };
} {
  return op.metadata?.metadata?.case === "metadataBrowserbase";
}

export function isSourceSyncOperationFileUpload(
  op: SourceSyncOperationResource,
): op is SourceSyncOperationResource & {
  metadata: {
    metadata: { case: "metadataFileUpload"; value: SourceSyncOperationMetadataFileUpload };
  };
} {
  return op.metadata?.metadata?.case === "metadataFileUpload";
}

export function isSourceSyncOperationWebhook(
  op: SourceSyncOperationResource,
): op is SourceSyncOperationResource & {
  metadata: { metadata: { case: "metadataWebhook"; value: SourceSyncOperationMetadataWebhook } };
} {
  return op.metadata?.metadata?.case === "metadataWebhook";
}
